export enum CoreApiTranslationTags {
  ResourceTranslation = 'ResourceTranslation',
  ResourceDeclinationDictionary = 'ResourceDeclinationDictionary',
}

export const coreApiTranslationTagTypes = Object.values(CoreApiTranslationTags);
